

// import axios from "axios";
// import Config from "../config";

// export const AuthInterceptor = (navigate) => {
//   // Request Interceptor
//   axios.interceptors.request.use(
//     async (config) => {
//       let access_token = null;
//       let loghistory_id = null;

//       // Call /api/session/ to get current session
//       try {
//         const res = await fetch(`/api/payload/`, {
//           credentials: "include", // send HttpOnly cookie
//         });

//         if (res.ok) {
//           const data = await res.json();
//           if (data?.payload) {
//             loghistory_id = data.payload.log_history_id;
//           } else {
//             console.warn("No active session found");
//           }
//         } else {
//           console.warn("Failed to fetch session");
//         }
//       } catch (err) {
//         console.error("Error fetching session", err);
//       }

//       // Set Authorization header if token exists
//       // if (access_token) {
//       //   config.headers.Authorization = `Bearer ${access_token}`;
//       // }

//       // Check remote logout
//       if (
//         config.url.includes("/api/") &&
//         !config.url.includes(`/api/logoutcheck/`) &&
//         loghistory_id
//       ) {
//         try {
//           const logoutCheck = await axios.post(
//             `/api/logoutcheck/`,
//             { loghistory_id }
//             // { headers: { Authorization: `Bearer ${access_token}` } }
//           );

//           if (!logoutCheck.data.is_logout_null) {

//             const TerminateOtherLogin = async () => {
//               const response = await fetch(`/api/logout/`, {
//                 method: "POST",
//                 headers: {
//                   "Content-Type": "application/json",
//                   // "Authorization": `Bearer ${access_token}`
//                 },
//                 credentials: "include",
//                 body: JSON.stringify({})
//               });

//               // Clear session and redirect
//               sessionStorage.clear();
//               // navigate("/");

//               // Reject with a custom message
//               return Promise.reject({ message: "Logged out remotely" });
//             };

//             // Call the function
//             await TerminateOtherLogin();
//           }
        
//         } catch (err) {
//         console.error("Logout check failed", err);
//         sessionStorage.clear();
//         // navigate("/");
//         return Promise.reject(err);
//       }
//     }

//       return config;
// },
// (error) => Promise.reject(error)
//   );

// // Response Interceptor
// axios.interceptors.response.use(
//   (response) => response,
//   (error) => Promise.reject(error)
// );
// };




import axios from "axios";

let requestInterceptorId = null;
let responseInterceptorId = null;
let isForceLoggingOut = false;
let refreshRequest = null;

const isAccessTokenError = (status, responseError = "") => {
  const errorText =
    typeof responseError === "string" ? responseError.toLowerCase() : "";

  return (
    status === 401 ||
    (status === 400 &&
      (
        errorText.includes("access_token") ||
        errorText.includes("token expired") ||
        errorText.includes("expired.") ||
        errorText.includes("invalid token") ||
        errorText.includes("no jwt payload")
      ))
  );
};

const refreshAccessToken = async () => {
  refreshRequest =
    refreshRequest ||
    axios.post("/sso/refresh-token/", {}, { withCredentials: true });

  try {
    return await refreshRequest;
  } finally {
    refreshRequest = null;
  }
};

const redirectToSessionExpired = (navigate) => {
  clearClientSession();

  if (navigate) {
    navigate("/error", {
      replace: true,
      state: {
        message: "Your session has expired or the token is invalid.",
      },
    });
  }
};

const clearCookie = (name) => {
  const expires = "Thu, 01 Jan 1970 00:00:00 GMT";
  document.cookie = `${name}=; expires=${expires}; path=/`;
  document.cookie = `${name}=; expires=${expires}; path=/; domain=${window.location.hostname}`;
};

const clearClientSession = () => {
  sessionStorage.clear();
  localStorage.removeItem("themeMode");
  clearCookie("access_token");
  clearCookie("refresh_token");
  clearCookie("ee_id");
};

const tryCloseCurrentTab = () => {
  window.open("", "_self");
  window.close();
};

export const logoutUser = async (navigate, options = {}) => {
  const {
    redirectTo = "/",
    closeTab = false,
  } = options;

  if (isForceLoggingOut) {
    return;
  }

  isForceLoggingOut = true;

  try {
    clearClientSession();

    if (closeTab) {
      tryCloseCurrentTab();
    }

    if (!window.closed && navigate) {
      navigate(redirectTo, { replace: true });
    }
  } finally {
    isForceLoggingOut = false;
  }
};

export const AuthInterceptor = (navigate) => {
  if (requestInterceptorId !== null) {
    axios.interceptors.request.eject(requestInterceptorId);
  }

  if (responseInterceptorId !== null) {
    axios.interceptors.response.eject(responseInterceptorId);
  }

  requestInterceptorId = axios.interceptors.request.use(
    (config) => config,
    (error) => Promise.reject(error)
  );

  responseInterceptorId = axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const status = error?.response?.status;
      const originalRequest = error?.config;
      const requestUrl = originalRequest?.url || "";
      const isRefreshRequest = requestUrl.includes("/sso/refresh-token/");
      const responseError =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "";
      const canAttemptRefresh = isAccessTokenError(status, responseError);

      if (
        !isForceLoggingOut &&
        canAttemptRefresh &&
        originalRequest &&
        !originalRequest._retry &&
        !isRefreshRequest
      ) {
        originalRequest._retry = true;

        try {
          await refreshAccessToken();

          return axios(originalRequest);
        } catch (refreshError) {
          redirectToSessionExpired(navigate);

          return Promise.reject(refreshError);
        }
      }

      if (
        !isForceLoggingOut &&
        !isRefreshRequest &&
        (status === 401 || status === 403)
      ) {
        redirectToSessionExpired(navigate);
      }

      return Promise.reject(error);
    }
  );
};






